<fui-rows>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="outletSalePeriods" [editable]="true" [entityPath]="'outletSalePeriods'"
                           (saved)="saveHandler($event)">
                <wbo-edit-link-column field="salePeriod.name" componentPath="salePeriod"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-text-column field="salePeriod.code"></wbo-text-column>
                <wbo-time-column field="salePeriod.startTime"></wbo-time-column>
                <wbo-checkbox-column field="disabled" [editable]="true"></wbo-checkbox-column>
                <wbo-time-column field="startTime" [editable]="true"></wbo-time-column>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>
